import {
  formatDuration,
  generateNickname,
  getDictionary,
  interpolate,
  type Dictionary,
} from '@anon-chat/shared';

const locale = import.meta.env.VITE_DEFAULT_LOCALE ?? 'ru';

/**
 * Словарь живёт в shared — тот же текст используют бэкенд (ошибки) и админка.
 * Добавление языка не требует изменений в компонентах.
 */
export const dictionary: Dictionary = getDictionary(locale);

export function useTranslations(): Dictionary {
  return dictionary;
}

export function t(
  template: string,
  params?: Readonly<Record<string, string | number>>,
): string {
  return interpolate(template, params);
}

/** Длительность словами шкалы: «45 с», «1 мин. 15 с». */
export function duration(seconds: number): string {
  return formatDuration(seconds, dictionary);
}

/** Прозвище собеседника в этом диалоге. */
export function nickname(anonymousId: string): string {
  return generateNickname(anonymousId, dictionary);
}

export function errorText(code: string | null | undefined): string {
  if (!code) {
    return dictionary.common.somethingWentWrong;
  }
  const messages = dictionary.errors as Record<string, string | undefined>;
  return messages[code] ?? dictionary.common.somethingWentWrong;
}
